import { Typography } from '@mui/material'
import React from 'react'
import useStyles from './useStyles'
import LocalFireDepartmentOutlinedIcon from '@mui/icons-material/LocalFireDepartmentOutlined'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined'
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined'
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
// import { useCookies } from 'react-cookie'

export const Home = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.boxTitle}>
        <Typography className={classes.title}>
          Bienvenidos a la Consola de Gestión Interna de Errepar+
        </Typography>
      </div>
      <div className={classes.boxSubtitle}>
        <Typography className={classes.subTitle}>
          Acá podrás gestionar la información de las organizaciones,
          suscriptores y usuarios
        </Typography>
      </div>
      <div className={classes.mainBoxes}>
        <div className={classes.boxTitleFire}>
          <LocalFireDepartmentOutlinedIcon className={classes.icon} />
          <Typography className={classes.subTitle}>
            Nuevas funcionalidades
          </Typography>
        </div>
        <div
          className={classes.boxes}
          onClick={() =>
            window.open(
              'https://docs.google.com/document/d/1nBCaA246LhBopl6MEbWiz_PZBjuxs_gmhKCFLqLjpaw/edit?usp=sharing',
              '_blank'
            )
          }
        >
          <div className={classes.insideBox}>
            <DescriptionOutlinedIcon className={classes.iconBoxes} />
            <div className={classes.insideBoxText}>
              <Typography className={classes.subTitle}>
                Manual de usuario
              </Typography>
              <Typography className={classes.description}>
                Para visualizar todas las funcionalidades de la consola de
                gestión interna podrá ingresar al manual.
              </Typography>
            </div>
          </div>
        </div>
        <div
          className={classes.boxes}
          onClick={() => (window.location.href = 'security/cognito')}
        >
          <div className={classes.insideBox}>
            <SecurityOutlinedIcon className={classes.iconBoxes} />
            <div className={classes.insideBoxText}>
              <Typography className={classes.subTitle}>
                Administración de usuarios en cognito
              </Typography>
              <div>
                <Typography className={classes.description}>
                  Se encuentra disponible la búsqueda del usuario por email,
                  reseteo de clave, simulación de inicio de sesión (Errepar+ y
                  Mi Estudio) y ver Productos suscriptor.
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <div
          className={classes.boxes}
          onClick={() => (window.location.href = 'organizations')}
        >
          <div className={classes.insideBox}>
            <BusinessOutlinedIcon className={classes.iconBoxes} />
            <div className={classes.insideBoxText}>
              <Typography className={classes.subTitle}>
                Organizaciones
              </Typography>
              <div>
                <Typography className={classes.description}>
                  En esta sección podrá buscar y/o gestionar las organizaciones
                  de Errepar+.
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <div
          className={classes.boxes}
          onClick={() => (window.location.href = 'subscribers')}
        >
          <div className={classes.insideBox}>
            <PeopleOutlineOutlinedIcon className={classes.iconBoxes} />
            <div className={classes.insideBoxText}>
              <Typography className={classes.subTitle}>Suscriptores</Typography>
              <div>
                <Typography className={classes.description}>
                  En esta sección podrá visualizar la información de un
                  suscriptor de Errepar+.
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <div
          className={classes.boxes}
          onClick={() => (window.location.href = 'users')}
        >
          <div className={classes.insideBox}>
            <PersonOutlineIcon className={classes.iconBoxes} />
            <div className={classes.insideBoxText}>
              <Typography className={classes.subTitle}>Usuarios</Typography>
              <div>
                <Typography className={classes.description}>
                  En esta sección podrá visualizar la información de un usuario
                  de Errepar+.
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
